import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import { Input, Select } from '../../components/ui/Input';
import { funcionariosApi, pontoApi } from '../../api/rh';
import { COLORS } from '../../theme';

const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
].map((m, i) => ({ value: String(i + 1), label: m }));

const ANO_ATUAL = new Date().getFullYear();
const ANOS = Array.from({ length: 5 }, (_, i) => ANO_ATUAL - 2 + i).map(a => ({ value: String(a), label: String(a) }));

export default function PontoList() {
  const hoje = new Date();
  const [mes, setMes] = useState(String(hoje.getMonth() + 1));
  const [ano, setAno] = useState(String(hoje.getFullYear()));
  const [funcionarios, setFuncionarios] = useState([]);
  const [ponto, setPonto] = useState({});
  const [salvandoId, setSalvandoId] = useState(null);

  const carregar = useCallback(() => {
    funcionariosApi.listar({ status: 'ativo' }).then(setFuncionarios).catch(() => {});
    pontoApi.listar(mes, ano).then(lista => {
      const mapa = {};
      lista.forEach(p => { mapa[p.funcionario_id] = p; });
      setPonto(mapa);
    }).catch(() => {});
  }, [mes, ano]);

  useEffect(() => { carregar(); }, [carregar]);

  const atualizarCampo = (funcionarioId, campo, valor) => {
    setPonto(p => ({ ...p, [funcionarioId]: { ...(p[funcionarioId] || {}), [campo]: valor } }));
  };

  const salvar = async (funcionarioId) => {
    setSalvandoId(funcionarioId);
    const dados = ponto[funcionarioId] || {};
    try {
      await pontoApi.salvar(funcionarioId, { mes, ano, faltas: dados.faltas || 0, horas_extras: dados.horas_extras || 0, observacao: dados.observacao || '' });
    } finally {
      setSalvandoId(null);
    }
  };

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', gap: 10 }}>
          <Select options={MESES} value={mes} onChange={e => setMes(e.target.value)} style={{ width: 160 }} />
          <Select options={ANOS} value={ano} onChange={e => setAno(e.target.value)} style={{ width: 110 }} />
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Funcionário</th>
              <th style={{ padding: 10, width: 120 }}>Faltas</th>
              <th style={{ padding: 10, width: 140 }}>Horas Extras</th>
              <th style={{ padding: 10 }}>Observação</th>
              <th style={{ padding: 10, width: 100 }}></th>
            </tr>
          </thead>
          <tbody>
            {funcionarios.map(f => {
              const dados = ponto[f.id] || {};
              return (
                <tr key={f.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                  <td style={{ padding: 10 }}>{f.nome}</td>
                  <td style={{ padding: 10 }}>
                    <Input type="number" value={dados.faltas ?? ''} onChange={e => atualizarCampo(f.id, 'faltas', e.target.value)} />
                  </td>
                  <td style={{ padding: 10 }}>
                    <Input type="number" step="0.01" value={dados.horas_extras ?? ''} onChange={e => atualizarCampo(f.id, 'horas_extras', e.target.value)} />
                  </td>
                  <td style={{ padding: 10 }}>
                    <Input value={dados.observacao ?? ''} onChange={e => atualizarCampo(f.id, 'observacao', e.target.value)} />
                  </td>
                  <td style={{ padding: 10 }}>
                    <button onClick={() => salvar(f.id)} disabled={salvandoId === f.id}
                      style={{ background: 'none', border: `1px solid ${COLORS.border}`, borderRadius: 7, padding: '5px 12px', fontSize: 12, fontWeight: 600, color: COLORS.primary, cursor: 'pointer' }}>
                      {salvandoId === f.id ? '...' : 'Salvar'}
                    </button>
                  </td>
                </tr>
              );
            })}
            {funcionarios.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum funcionário ativo.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
